module.exports = __webpack_public_path__ + "media/toolkits/HVAC-mobile-header-f86bb8c5.jpg";